module.exports = __webpack_public_path__ + "static/media/Maurice.b5c9f972.png";